//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "TimelineItemCard",
  props: {
    cardHeader: {
      type: Boolean,
      default: false
    }
  }
});